"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMonths;
var _getMonth = _interopRequireDefault(require("date-fns/getMonth"));
var _react = require("react");
var _index = require("./index");
const WIDTH = 'wide';
const FOR_SELECT = false;

/**
 * @typedef {Object} useMonthsResponse
 * @property {Array} allMonths - Array of strings of localized months.
 * @property {Array} currentYearMonths - Same shape as allMonths but only including months up until today's date.
 */

/**
 * @typedef {Array} useMonthsResponseForSelect
 * @property {Array.<monthsForSelect>} allMonths - Array of objects with a shape of label and value.
 * @property {Array.<monthsForSelect>} currentYearMonths - A filtered Array of objects with a shape of label and value of current months in the year.
 */

/**
 * @typedef {Object} monthsForSelect
 * @property {string} label - A localized string value of the month.
 * @property {string} value - Index + 1 value of the month of the year.
 */

/**
 * Custom hook function that takes in options, and returns all months and months based on the current year.
 * @function useMonths
 * @param {Object} [options] - Object of options.
 * @param {String} [options.width] - Option given to date-fns localize.month.
 * @param {Boolean} [options.forSelect] - Instead of returning an array of strings, it will give an array of objects with label and value key names.
 * @example
 * import useMonths from '@teladoc/ui/Context/l10n/DateTime/useMonths';
 *
 * const SomeComponent = () => {
 *     const {allMonths} = useMonths({
 *         width: 'abbreviated',
 *     });
 *
 *     return allMonths.map(month => <p key={month}>{month}</p>);
 * }
 * @returns {useMonthsResponse|useMonthsResponseForSelect} - An object containing all months and current months in the year.
 */
function useMonths() {
  let {
    width = WIDTH,
    forSelect = FOR_SELECT,
    startingMonthZero = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    width: WIDTH,
    forSelect: FOR_SELECT,
    startingMonthZero: false
  };
  const {
    locale
  } = (0, _index.useL10nDateTimeContext)();
  const allMonths = (0, _react.useMemo)(() => Array.from(Array(12).keys()).map(i => {
    const month = locale.localize.month(i, {
      width
    });
    if (forSelect) {
      return {
        label: month,
        value: String(startingMonthZero ? i : i + 1)
      };
    }
    return month;
  }), [locale, width, forSelect, startingMonthZero]);
  const currentYearMonths = (0, _react.useMemo)(() => allMonths.filter((month, i) => i <= (0, _getMonth.default)(new Date())), [allMonths]);
  return {
    allMonths,
    currentYearMonths
  };
}